import { render, staticRenderFns } from "./MultipleTeaorSelect.vue?vue&type=template&id=5f2dce86&scoped=true"
import script from "./MultipleTeaorSelect.vue?vue&type=script&lang=js"
export * from "./MultipleTeaorSelect.vue?vue&type=script&lang=js"
import style0 from "./MultipleTeaorSelect.vue?vue&type=style&index=0&id=5f2dce86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2dce86",
  null
  
)

export default component.exports